import React, {useContext, useEffect} from 'react';
import {useSearchParams} from 'react-router-dom';
import {useIntl} from 'react-intl';

import {Space, Tabs} from 'antd';
import AppPageMetadata from '@crema/core/AppPageMetadata';
import AppsContainer from '@crema/core/AppsContainer';
import AppsHeader from '@crema/core/AppsContainer/AppsHeader';
import AppsContent from '@crema/core/AppsContainer/AppsContent';
import {PatientContext, Provider} from '../PatientContext';
import {useHealthInfo} from 'hooks/HealthHooks';
import PatientInfo from './PatientInfo';
import TreatmentList from './Treatments/TreatmentList';
import OrderList from '../../Orders/OrderList';
import {Vitals} from './Vitals';
import DiagnosticList from './Diagnostics/DiagnosticList';
import RequestList from '../../Medications/RequestList';

const DetailTab = () => {
  const intl = useIntl();
  const {patient} = useHealthInfo();
  const [searchParams] = useSearchParams();
  const view = searchParams.get('view');

  const patientContext = useContext(PatientContext);
  const {selectedPatient, setSelectedPatient} = patientContext;

  useEffect(() => {
    if (!selectedPatient && patient) {
      setSelectedPatient(patient);
    }
  }, [patient]);

  return (
    <>
      <AppPageMetadata title={intl.messages['common.detail']} />
      {selectedPatient?.id && <Vitals patientId={selectedPatient?.id} />}
      <AppsContainer
        title={intl.messages['patient.info']}
        fullView
        type='bottom'>
        <AppsHeader key={'header'}>
          <div className='customer-header'>
            <div className='customer-header-input-view' />
          </div>
        </AppsHeader>

        <AppsContent
          key={'content'}
          style={{
            paddingTop: 10,
            paddingBottom: 10,
          }}>
          <Space
            direction='vertical'
            style={{width: '100%', paddingLeft: 10, paddingRight: 10}}>
            <Tabs
              defaultActiveKey={view ? view : 'detail'}
              destroyInactiveTabPane={true}>
              <Tabs.TabPane tab={intl.messages['common.detail']} key='detail'>
                <PatientInfo />
              </Tabs.TabPane>
              <Tabs.TabPane
                tab={intl.messages['patient.examinationHistory']}
                key='orders'>
                <OrderList patientId={selectedPatient?.id} />
              </Tabs.TabPane>
              <Tabs.TabPane
                tab={intl.messages['treatment.list']}
                key='treatments'>
                <TreatmentList />
              </Tabs.TabPane>
              <Tabs.TabPane
                tab={intl.messages['patient.diagnosticHistory']}
                key='diagnostics'>
                <DiagnosticList patientId={selectedPatient?.id} />
              </Tabs.TabPane>
              <Tabs.TabPane
                tab={intl.messages['patient.medicationHistory']}
                key='medications'>
                <RequestList patientId={selectedPatient?.id} />
              </Tabs.TabPane>
            </Tabs>
          </Space>
        </AppsContent>
      </AppsContainer>
    </>
  );
};

export default function PatientDetail() {
  return (
    <Provider>
      <DetailTab />
    </Provider>
  );
}
